module.exports = __webpack_public_path__ + "img/75ne.749a0cbf.svg";